import "../css/Menu.css";

const menu = [
  {
    category: "Espresso",
    items: [
      { name: "Espresso", price: "4" },
      { name: "Double Espresso", price: "5" },
      { name: "Americano", price: "5" },
    ],
  },
  {
    category: "Milk & Foam",
    items: [
      { name: "Cappuccino", price: "6" },
      { name: "Flat White", price: "6.5" },
      { name: "Latte", price: "6.5" },
    ],
  },
  {
    category: "Signature",
    items: [
      { name: "Midnight Mocha", price: "7" },
      { name: "Burnt Sugar Latte", price: "7.5" },
      { name: "Olive Oil Espresso", price: "7" },
    ],
  },
];

const Menu = () => {
  return (
    <main className="night-menu">

      {/* INTRO */}
      <section className="menu-intro">
        <h1>Menu</h1>
        <p>
          A focused selection.<br />
          Crafted for the night.
        </p>
      </section>

      {/* MENU GRID */}
      <section className="menu-grid">
        {menu.map((section, i) => (
          <div key={i} className="menu-section">
            <h2>{section.category}</h2>

            <div className="menu-items">
              {section.items.map((item, idx) => (
                <div key={idx} className="menu-item">
                  <span className="item-name">{item.name}</span>
                  <span className="item-price">${item.price}</span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>

      {/* NOTE */}
      <section className="menu-note">
        <p>
          Plant-based milk available.<br />
          No syrups. No shortcuts.
        </p>
      </section>

    </main>
  );
};

export default Menu;
